import { Page, Card, BlockStack, Text, Link } from '@shopify/polaris'

export function HelpPage() {
  return (
    <Page fullWidth title="Help & Support">
      <Card>
        <BlockStack gap="300">
          <Text as="h2" variant="headingMd">
            Need help?
          </Text>
          <Text as="p">
            Reach out to our support team and we&apos;ll get back to you within one business day.
          </Text>
          <Text as="p">
            Email: <Link url="mailto:support@codingharbor.com">support@codingharbor.com</Link>
          </Text>
        </BlockStack>
      </Card>
    </Page>
  )
}
